import { render } from "./DiscountTable.vue?vue&type=template&id=c1d822e2"
import script from "./DiscountTable.vue?vue&type=script&lang=ts"
export * from "./DiscountTable.vue?vue&type=script&lang=ts"
script.render = render

export default script